var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.651,
    height: 16,
    viewBox: "0 0 10.651 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9304",
    "data-name": "Grupo 9304",
    transform: "translate(1199.931 143.25) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9303",
    "data-name": "Grupo 9303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9302",
    "data-name": "Grupo 9302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9301",
    "data-name": "Grupo 9301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11337",
    "data-name": "Caminho 11337",
    d: "M1199.931,137.924l-1.212-1.212-4.113,4.113-4.113-4.113-1.212,1.212,5.325,5.326Z",
    fill: "#415364"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "Linha_651",
    "data-name": "Linha 651",
    y1: 13.846,
    transform: "translate(1194.606 127.25)",
    fill: "none",
    stroke: "#415364",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectUp);
export default __webpack_public_path__ + "static/media/select-up.c1c1712d14f4fdfc212212becda5ca3b.svg";
export { ForwardRef as ReactComponent };